import { NAMED_CACHE_NAME } from "../../utils/sw/sw.constants";

export const _sharedActionsConstantsSW = {
  // SW logic
  UPDATE_IS_SW_REGISTERED: "sw/UPDATE_IS_SW_REGISTERED",
  UPDATE_IS_SW_INIT: "sw/UPDATE_IS_SW_INIT",
  UPDATE_IS_SW_INIT_DATA_RETRIEVED: "sw/UPDATE_IS_SW_INIT_DATA_RETRIEVED",

  GET_INIT_STATUS: "sw/GET_INIT_STATUS",
  // ==============================

  // Website logic
  DOWNLOAD_WEBSITE: "sw/DOWNLOAD_WEBSITE",
  CANCEL_DOWNLOAD_WEBSITE: "sw/DOWNLOAD_WEBSITE_URLS_FOR_OFFLINE_USE",

  UPDATE_WEBSITE_URLS: "sw/UPDATE_WEBSITE_URLS",
  UPDATE_WEBSITE_URLS_STATUSES: "sw/UPDATE_WEBSITE_URLS_STATUSES",

  UPDATE_IS_WEBSITE_DOWNLOADING: "sw/UPDATE_IS_WEBSITE_DOWNLOADING",
  UPDATE_IS_ERROR_WEBSITE_DOWNLOAD: "sw/UPDATE_IS_ERROR_WEBSITE_DOWNLOAD",
  UPDATE_DOWNLOAD_WEBSITE_URLS_PROGRESS: "sw/UPDATE_DOWNLOAD_WEBSITE_URLS_PROGRESS",
  // ==============================

  // Downloaded data (for offline use) logic
  DOWNLOAD_DATA: "sw/DOWNLOAD_DATA",
  CANCEL_DOWNLOAD_DATA: "sw/CANCEL_DOWNLOAD_DATA",
  UPDATE_DOWNLOAD_PROGRESS: "sw/UPDATE_DOWNLOAD_PROGRESS",
  UPDATE_KEYS_AVAILABLE: "sw/UPDATE_KEYS_AVAILABLE",
  PULL: "sw/PULL",
  PULL_SUCCESS: "sw/PULL_SUCCESS",
  // ==============================
};

export const _sharedActionsSW = {
  // SW logic
  updateIsSWRegistered: (flag) => ({
    type: _sharedActionsConstantsSW.UPDATE_IS_SW_REGISTERED,
    data: flag
  }),
  updateIsSWInit: (flag) => ({
    type: _sharedActionsConstantsSW.UPDATE_IS_SW_INIT,
    data: flag
  }),
  updateIsSWInitDataRetrieved: (flag) => ({
    type: _sharedActionsConstantsSW.UPDATE_IS_SW_INIT_DATA_RETRIEVED,
    data: flag
  }),

  getInitStatus: () => ({
    type: _sharedActionsConstantsSW.GET_INIT_STATUS
  }),
  // ==============================

  // Website logic
  downloadWebsite: () => ({
    type: _sharedActionsConstantsSW.DOWNLOAD_WEBSITE,
  }),
  cancelDownloadWebsite: () => ({
    type: _sharedActionsConstantsSW.CANCEL_DOWNLOAD_WEBSITE,
  }),
  updateWebsiteUrls: (urls) => ({
    type: _sharedActionsConstantsSW.UPDATE_WEBSITE_URLS, data: urls
  }),
  updateIsWebsiteUrlsDownloading: (flag) => ({
    type: _sharedActionsConstantsSW.UPDATE_IS_WEBSITE_DOWNLOADING, data: flag
  }),
  updateIsErrorWebsiteDownload: (flag) => ({
    type: _sharedActionsConstantsSW.UPDATE_IS_ERROR_WEBSITE_DOWNLOAD, data: flag
  }),
  updateWebsiteUrlsStatuses: (data) => ({
    type: _sharedActionsConstantsSW.UPDATE_WEBSITE_URLS_STATUSES, data
  }),
  updateWebsiteUrlsProgress: (progress) => ({
    type: _sharedActionsConstantsSW.UPDATE_DOWNLOAD_WEBSITE_URLS_PROGRESS, data: progress
  }),
  // ==============================

  // Downloaded data (for offline use) logic
  downloadDataForOffline: (cacheName, data, onSuccess) => ({
    type: _sharedActionsConstantsSW.DOWNLOAD_DATA,
    data: { cacheName, data, onSuccess }
  }),
  cancelDownloadData: (cacheName, item) => ({
    type: _sharedActionsConstantsSW.CANCEL_DOWNLOAD_DATA,
    data: { cacheName, item }
  }),
  updateKeysAvailable: (cacheName, keys) => ({
    type: _sharedActionsConstantsSW.UPDATE_KEYS_AVAILABLE, data: { cacheName, keys }
  }),
  pull: (cacheName, key) => ({
    type: _sharedActionsConstantsSW.PULL, data: { cacheName, key }
  }),
  pullSuccess: (cacheName, key, value) => ({
    type: _sharedActionsConstantsSW.PULL_SUCCESS, data: { cacheName, key, value }
  }),
  updateDownloadProgress: (type, id, progress) => ({
    type: _sharedActionsConstantsSW.UPDATE_DOWNLOAD_PROGRESS,
    data: { type, id, progress }
  }),
  // =========================

  /* ===== Derivatives methods, for easier code reading ===== */
  downloadDataBookData: (books, onSuccess) => {
    return _sharedActionsSW.downloadDataForOffline(NAMED_CACHE_NAME.BOOK_DATA, books, onSuccess);
  },
  cancelDownloadDataBookData: (book) => {
    return _sharedActionsSW.cancelDownloadData(NAMED_CACHE_NAME.BOOK_DATA, book);
  },
  updateDownloadProgressBookData: (bookId, progress) => {
    return _sharedActionsSW.updateDownloadProgress(NAMED_CACHE_NAME.BOOK_DATA, bookId, progress);
  },
  pullBookData: (bookId) => _sharedActionsSW.pull(NAMED_CACHE_NAME.BOOK_DATA, bookId),

  downloadDataAudio: (audioChapters) => {
    return _sharedActionsSW.downloadDataForOffline(
      NAMED_CACHE_NAME.AUDIO_FILE, audioChapters
    );
  },
  cancelDownloadDataAudio: (audioChapter) => {
    return _sharedActionsSW.cancelDownloadData(NAMED_CACHE_NAME.AUDIO_FILE, audioChapter);
  },
  pullAudio: (chapterId) => _sharedActionsSW.pull(NAMED_CACHE_NAME.AUDIO_FILE, chapterId),
  updateDownloadProgressAudio: (chapterId, progress) => {
    return _sharedActionsSW.updateDownloadProgress(
      NAMED_CACHE_NAME.AUDIO_FILE, chapterId, progress
    );
  },

  // Waveforms are downloaded with audios for now as it is easier.
  // downloadDataForOfflineWaveform: (toc, onSuccess) => {
  //   return _sharedActionsSW.downloadDataForOffline(NAMED_CACHE_NAME.WAVEFORM, toc, onSuccess);
  // },

  pullProgressWaveform: (chapterId) => _sharedActionsSW.pull(NAMED_CACHE_NAME.WAVEFORM, chapterId),
  updateDownloadProgressWaveform: (id, progress) => {
    return _sharedActionsSW.updateDownloadProgress(NAMED_CACHE_NAME.WAVEFORM, id, progress);
  },
  // ==============================
};
